import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-back-button',
  templateUrl: './ui-back-button.component.html',
  styleUrls: ['./ui-back-button.component.scss']
})
export class UiBackButtonComponent {
  @Input() translateKey: string = 'common.back';
  @Input() showTextOnlyOnDesktop: boolean = true;

  @Output() onClick = new EventEmitter<void>();
}
